module.exports = __webpack_public_path__ + "static/media/preview.0a9f35f4.svg";